import { RuleResult } from 'types/DeclarationP5'

const C0101Validator = {
  validateAuthorisationRequirement: (reducedDatasetIndicator?: string): RuleResult => (reducedDatasetIndicator === '1' ? 'REQUIRED' : 'OPTIONAL'),
}

export default C0101Validator
